import { render, staticRenderFns } from "./SelectChannel.vue?vue&type=template&id=3de7d484&scoped=true"
import script from "./SelectChannel.vue?vue&type=script&lang=js"
export * from "./SelectChannel.vue?vue&type=script&lang=js"
import style0 from "./SelectChannel.vue?vue&type=style&index=0&id=3de7d484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de7d484",
  null
  
)

export default component.exports